<template>
  <div>
    <h1>Máquinas</h1>
    <v-divider class="my-5"></v-divider>
    <v-simple-table
      fixed-header
    >
      <template v-slot:default>
        <thead>
        <tr>
          <th class="text-left">
            Curso
          </th>
          <th class="text-left">
            Nome
          </th>
          <th class="text-left">
            IP
          </th>
          <th class="text-left">
            Estado
          </th>
          <th class="text-left">
            Limite acesso
          </th>
          <th class="text-left">
          </th>
        </tr>
        </thead>
        <tbody>
        <tr
          v-for="machine in machines"
          :key="machine.id"
        >
          <td>{{ machine.course.name }} <small>{{ machine.course.code }}</small></td>
          <td>{{ machine.name }}</td>
          <td>{{ machine.publicIp }} <small><strong>aluno@{{ machine.publicIp }}</strong></small></td>
          <td>{{ machine.state }}</td>
          <td>{{ getLimit(machine.enrolment) }}</td>
          <td>
            <v-btn text :disabled="!canStart(machine)" @click="start(machine)" color="success">
              <v-icon left>mdi-play</v-icon>
              Iniciar
            </v-btn>
            <v-btn text :disabled="!canStop(machine)" @click="stop(machine)" color="error">
              <v-icon left>mdi-stop</v-icon>
              Parar
            </v-btn>
            <v-btn text :disabled="!canReset(machine)" @click="reset(machine)" color="error">
              <v-icon left>mdi-restart</v-icon>
              Reiniciar
            </v-btn>
            <v-btn text @click="status(machine)" color="primary">
              <v-icon left>mdi-reload</v-icon>
              Atualizar estado
            </v-btn>
            <v-btn text @click="ip(machine)" color="primary">
              <v-icon left>mdi-ip</v-icon>
              Atualizar IP
            </v-btn>
            <v-btn text :disabled="!canSsh(machine)" @click="ssh(machine)" color="secondary">
              <v-icon left>mdi-ssh</v-icon>
              Conectar
            </v-btn>
          </td>
        </tr>
        </tbody>
      </template>
    </v-simple-table>
    <v-alert v-if="!machines.length" type="info">
      Nenhuma máquina encontrada.
    </v-alert>
    <v-dialog v-model="loading" persistent fullscreen>
      <v-container fluid fill-height style="background-color: rgba(255, 255, 255, 0.5);">
        <v-layout justify-center align-center>
          <v-progress-circular
            indeterminate
            color="#00aab0"
            :size="100"
            :width="10"
          >
          </v-progress-circular>
        </v-layout>
      </v-container>
    </v-dialog>
    <v-snackbar v-model="snackbar">
      {{ snackbarText }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>

import MachineService from '@/services/machine/machine.service';
import StudentService from '@/services/student/student.service';
import UserService from '@/services/user/user.service';
import User from '@/models/user';

const studentService = new StudentService();
const userService = new UserService();
const machineService = new MachineService();

export default {
  name: 'StudentMachines',
  data: () => ({
    user: new User(),
    machines: [],
    loading: false,
    snackbar: false,
    snackbarText: '',
  }),
  mounted() {
    userService.get()
      .then((response) => {
        this.user.id = response.data.id;
        this.user.name = response.data.name;
        this.user.email = response.data.email;
        this.user.roles = response.data.roles;
        this.user.auth = response.data.auth;
      })
      .catch(console.error);

    this.loadMachines();
  },
  methods: {
    showSnack(text) {
      this.snackbar = true;
      this.snackbarText = text;
    },
    loadMachines() {
      this.loading = true;

      studentService.machines()
        .then((response) => this.machines = response.data)
        .catch(console.error)
        .finally(() => this.loading = false);
    },
    getLimit(enrolment) {
      if (enrolment.type === 'unlimited') {
        return 'Ilimitado';
      }

      if (enrolment.state === 'expired') {
        return 'Expirado';
      }

      const date = new Date(enrolment.accessLimit);

      return `${date.getDate()}/${date.getMonth()+1}/${date.getFullYear()}`;
    },
    canStart(machine) {
      return machine.state === 'stopped';
    },
    canStop(machine) {
      return machine.state === 'running';
    },
    canReset(machine) {
      return machine.state === 'running';
    },
    canSsh(machine) {
      return machine.state === 'running';
    },
    start(machine) {
      this.loading = true;

      machineService.start(machine.id)
        .then((response) => {
          this.showSnack(response.data.message);
          this.status(machine);
          this.ip(machine);
        })
        .catch(console.error)
        .finally(() => this.loading = false);
    },
    stop(machine) {
      this.loading = true;

      machineService.stop(machine.id)
        .then((response) => {
          this.showSnack(response.data.message);
          this.status(machine);
        })
        .catch(console.error)
        .finally(() => this.loading = false);
    },
    reset(machine) {
      this.loading = true;

      machineService.reset(machine.id)
        .then((response) => {
          this.showSnack(response.data.message);
          this.status(machine);
          this.ip(machine);
        })
        .catch(console.error)
        .finally(() => this.loading = false);
    },
    status(machine) {
      this.loading = true;

      machineService.status(machine.id)
        .then((response) => {
          machine.state = response.data.state;
        })
        .catch(console.error)
        .finally(() => this.loading = false);
    },
    ip(machine) {
      this.loading = true;

      machineService.ip(machine.id)
        .then((response) => {
          machine.publicIp = response.data.publicIp;
        })
        .catch(console.error)
        .finally(() => this.loading = false);
    },
    ssh(machine) {
      const route = this.$router.resolve({ name: 'StudentMachineSsh', params: { machineId: machine.id } });

      window.open(route.href, '_blank');
    },
  },
};
</script>

<style>

</style>
